import React, { useState, useEffect } from 'react'
import message from '../../original-code/antd-message'
import request from '../../utils/request'
import util from '../../utils/util'
import Icon from '../icon'
import { IDEA_MASS_ROLE } from '../enum'
import './index.less'

let mnTimer = null
export default (props) => {
  message.destroy()
  message.success(<Content {...props} />, 0)
}

const Content = ({
  time = 5,
  name,
  data,
  firstData,
  inspirationList = [],
  collectIdList = [],
  loginUserInfo,
  isFast,
  callback
}) => {
  const [count, setCount] = useState(time)
  const [audit, setAudit] = useState(false)
  const [weekData, setWeekData] = useState({})
  useEffect(() => {
    request.get('/zhikuan/mn/propagate/blog-this-week-collect').then(result => {
      setWeekData({
        blogNum: result.blogNum,
        ranking: result.ranking
      })
    })
  }, [])

  useEffect(() => {
    mnTimer = setInterval(() => { setCount(pre => pre - 1) }, 1000)
  }, [])

  useEffect(() => {
    if (count <= 0) {
      destroyMessage()
    }
  }, [count])

  const destroyMessage = () => {
    clearInterval(mnTimer)
    message.destroy()
  }

  const changeInspiration = () => {
    destroyMessage()
    callback?.()
  }

  const submitAudit = async () => {
    const success = await request.post('/zhikuan/ins/inspiration/batch-mark', {
      collectIdList,
      markTimes: 0,
      markStatus: 3,
    })
    if (success) {
      setAudit(true)
      message.success('提交审核成功')
    }
  }

  const authExitCooperation = [IDEA_MASS_ROLE.GATHER].includes(loginUserInfo?.role)
  const _data = data || firstData
  const link = _data.parentId && _data.parentId !== -1
    ? `/meinian/home/coll/detail/${_data.id}?tab=1&inspirationId=${_data.id}&parentId=${_data.parentId}&name=${_data.name}&trackSourceType=采集时跳转`
    : `/meinian/home/coll/detail/${_data.id}?inspirationId=${_data.id}&trackSourceType=采集时跳转`

  return <div className="mn-message-container">
    <div className="container-collect">
      <div>
        <span className="collect-title">已采集至</span>
        <span className="collect-name">{name}</span>
        {inspirationList.length > 1 && <span className="collect-title">等{inspirationList.length}个灵感集</span>}
      </div>
      <div>
        <span className="collect-time">{`(${count}s)`}</span>
        <Icon
          type="m-guanbi"
          style={{ color: 'var(--m-text-2)', fontSize: 20, marginLeft: 8, cursor: 'pointer' }}
          onClick={destroyMessage}
        />
      </div>
    </div>
    <div className="container-submit">
      <div className="success-title">本周采集{weekData.blogNum}，团队内排名NO.{weekData.ranking}</div>
      <div className="success-btns">
        {
          authExitCooperation && collectIdList.length === 1 && !audit && <div className="success-toview" style={{ marginRight: '8px' }} onClick={submitAudit}>提交审核</div>
        }
        {isFast && <div className="success-toview" onClick={changeInspiration}>更改灵感集</div>}
        <a
          onClick={(e) => {
            util.track('mn-collect-complete-link', {})
            if (inspirationList.length > 1) {
              window.open('/meinian/home/coll')
            } else {
              window.open(link)
            }
            destroyMessage()
            e?.stopPropagation()
          }}
          target="_blank"
          rel="noreferrer"
          className="success-toview"
          style={{ marginLeft: 8 }}
        >点击查看</a>
      </div>
    </div>
  </div>
}
